import { doc, getFirestore, updateDoc  } from 'firebase/firestore';
import type { TableColumnConfig } from '../tableMain';

export type FirebaseCellEditResult = [boolean, string?];

interface FirebaseCellEditParams {
    collectionName: string;
    docId: string;
    fieldName: string;
    oldValue: unknown;
    newValue: unknown;
    colType?: TableColumnConfig['colType'];
}

const normalizeFirebaseValue = (
    value: unknown,
    colType?: TableColumnConfig['colType']
): unknown => {
    if (colType === 'boolean') {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value === 1;
        if (typeof value === 'string') {
        const v = value.trim().toLowerCase();
        if (v === 'true' || v === '1' || v === 'yes') return true;
        if (v === 'false' || v === '0' || v === 'no') return false;
        }
        return Boolean(value);
    }

    if (colType === 'number' || colType === 'accounting') {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (trimmed === '') return null;
            const parsed = Number(trimmed.replace(/,/g, ''));
            return Number.isNaN(parsed) ? null : parsed;
        }
        return value;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed === '' ? null : trimmed;
    }

    if (value === undefined) return null;
    return value;
};

export async function submitFirebaseCellEdit(
    params: FirebaseCellEditParams
): Promise<FirebaseCellEditResult> {
    const { collectionName, docId, fieldName, newValue, colType } = params;

    if (!collectionName || !docId || !fieldName) {
        return [false, 'Missing collection, docId, or fieldName'];
    }

    try {
        const db = getFirestore();
        const userRef = doc(db, collectionName, docId);
        const normalizedValue = normalizeFirebaseValue(newValue, colType);

        await updateDoc(userRef, {
            [fieldName]: normalizedValue,
        });

        return [true, undefined];
    } catch (error) {
        const message =
            error instanceof Error ? error.message : 'Unknown Firebase edit error';
        console.error('Firebase edit failed', { collectionName, docId, fieldName, error });
        return [false, message];
    }
}